import React, { useMemo } from "react";
import { useMediaQuery } from "@mui/material";

import { ProgressBar } from "./ProgressBar";
import { ProgressBarProvider } from "./ProgressBarProvider";
import { StyledProgressBarContainer } from "./styled";
import { useProgressBar } from "./hooks/useProgressBar";
import { ICONS, Icon } from "../Icons";

const renderSteps = (steps, isMobile, currentStepName) => {
  return steps.map((step, index) => {
    if (isMobile && currentStepName !== step.name) {
      return null;
    }

    return (
      <div
        className={isMobile ? "mobileProgressBarContainer" : "desktopProgressBarContainer"}
        key={step.name}
      >
        {isMobile ? (
          <div className="mobileProgressContainer">
            <div className="mobileProgressBarLabel">
              <Icon className={"progressBarIcon"} name={ICONS.progressIcon} alt="selected icon" />
              <span className="mobileProgressLabelStepName">{step.name}</span>
            </div>
            <ProgressBar
              label={step.name}
              value={step?.value}
              status={step?.status}
              isMobile={isMobile}
            />
          </div>
        ) : (
          <ProgressBar label={step.name} value={step?.value} status={step?.status} />
        )}
      </div>
    );
  });
};

const ProgressBarContainer = React.memo(() => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const { showProgressBar, steps, currentStepName } = useProgressBar();

  const renderedSteps = useMemo(() => {
    if (!steps || steps.length === 0) return [];
    return renderSteps(steps, isMobile, currentStepName);
  }, [steps, isMobile, currentStepName]);

  if (showProgressBar === -1) {
    return null;
  }

  return <StyledProgressBarContainer>{renderedSteps}</StyledProgressBarContainer>;
});

ProgressBarContainer.displayName = "ProgressBarContainer";

const HeaderProgressBar = () => {
  return (
    <ProgressBarProvider>
      <ProgressBarContainer />
    </ProgressBarProvider>
  );
};

export default HeaderProgressBar;
